import React, {useEffect, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import * as action from "../../../../_redux/DeploymentRTSPJobs/DeploymentRTSPJobsAction";
import CommonModal from "../../../../../../../../utils/SuperAdmin/CommonModal";
import ReactSelectDropDownCommon from "../../../../../../../../utils/SuperAdmin/ReactSelectDropDownCommon";

export function DeploymentRTSPJobStartDialog({ id, show, onHide }) {
  const dispatch = useDispatch();
  const initialTitle = "Are you sure? to deploy";
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [alertTitle, setAlertTitle] = useState(initialTitle);
  const [selectedVerifyRtspJob, setSelectedVerifyRtspJob] = useState(null);
  const [selectedIsHideFrame, setSelectedIsHideFrame] = useState(null);
  const [showSweetAlert, setShowSweetAlert] = useState(false); // <-- new state

  const handleChangeRtspJob = (option) => {
    setSelectedVerifyRtspJob(option);
  };
  const handleChangeIsHideFrame = (option) => {
    setSelectedIsHideFrame(option);
  };

  const { deploymentRTSPJobsFetchedById } = useSelector(
      (state) => ({
        deploymentRTSPJobsFetchedById:
        state.deploymentRTSPJobs1.deploymentRTSPJobsFetchedById,
      }),
      shallowEqual
  );

  useEffect(() => {
    if (id) dispatch(action.fetchDeploymentRTSPJobById(id));
  }, [id, dispatch]);

  // This runs when clicking "Save" in modal
  const handleSubmit = () => {
    if (!selectedVerifyRtspJob) {
      alert("Please select verify rtsp job");
      return;
    }
    // Close modal & open SweetAlert
    setShowSweetAlert(true);
  };

  const confirmSubmitData = () => {
    setLoading(true);
    setAlertTitle("Deploying");
    const data =
      {
        deployment_job_rtsp_id: id,
        is_only_record: selectedVerifyRtspJob?.value,
        deploymodel_detail: {
          IS_HIDE: selectedIsHideFrame?.value
        }
      }
    dispatch(action.startDeploymentRTSPJobById(data))
        .then(() => {
          setLoading(false);
          setSuccess(true);
          setAlertTitle("Deployed");
          setTimeout(() => {
            setSuccess(false);
            setAlertTitle(initialTitle);
            setShowSweetAlert(false); // close alert
            onHide(); // close the main dialog
          }, 750);
        }).catch((error) => {
          console.error(error);
          setLoading(false);
          setSuccess(false);
    });
  };

  return (
      <>
        <CommonModal
            size="sm"
            show={show}
            handleClose={onHide}
            arialabelledby="example-modal-sizes-title-lg"
            title={deploymentRTSPJobsFetchedById?.user_details?.company?.company_name}
            closeButtonFlag={true}
            applyButton={true}
            submitEmployee={handleSubmit}
            content={
              <>
                <div>{deploymentRTSPJobsFetchedById?.model_details?.model_name}</div>
                <div className={"mb-5 mt-5"}>
                  <ReactSelectDropDownCommon
                      isSearchable={true}
                      placeholder="Select verify rtsp job"
                      value={selectedVerifyRtspJob}
                      onChange={handleChangeRtspJob}
                      options={verifyRtspJobOptions}
                  />
                </div>
                <div>
                  <ReactSelectDropDownCommon
                      isSearchable={true}
                      placeholder="Select isHide frame"
                      value={selectedIsHideFrame}
                      onChange={handleChangeIsHideFrame}
                      options={isHideFrameOptions}
                  />
                </div>
              </>
            }
        />
        {showSweetAlert && (
            <SweetAlert
                info={!success}
                success={success}
                showCancel={!loading && !success}
                showConfirm={!loading && !success}
                closeOnClickOutside={!loading}
                confirmBtnText="Confirm"
                confirmBtnBsStyle="primary"
                cancelBtnBsStyle="light"
                cancelBtnStyle={{ color: "black" }}
                title={alertTitle}
                onConfirm={confirmSubmitData}
                onCancel={() => setShowSweetAlert(false)}
                focusCancelBtn
            >
              {loading ? (
                  <div className="overlay-layer bg-transparent text-center mt-5">
                    <div className="spinner-border text-info text-center" />
                  </div>
              ) : null}
            </SweetAlert>
        )}
      </>
  );
}

const verifyRtspJobOptions = [
  { value: true, label: "Frame To Store" },
  { value: false, label: "AI Pipeline" },
];
const isHideFrameOptions = [
  { value: true, label: "manually check frame" },
  { value: false, label: "without check frame" },
];

